import React, { Component } from 'react';
import firebase from '../Config/Firebase';

export default class PayButton extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      allDisplayItems: [],
      paymentError: false
    }
  }

  getGooglePaymentsConfiguration(allowedCardNetworks) {
    return {
      // A merchant ID is available after approval by Google.
      // 'merchantId':'01234567890123456789',
      environment: 'TEST',
      apiVersion: 1,
      allowedPaymentMethods: ['CARD', 'TOKENIZED_CARD'],
      paymentMethodTokenizationParameters: {
        tokenizationType: 'PAYMENT_GATEWAY',
        // Check with your payment gateway on the parameters to pass.
        // @see {@link https://developers.google.com/pay/api/web/reference/object#Gateway}
        parameters: {
          'gateway': 'example',
          'gatewayMerchantId': 'exampleGatewayMerchantId'
        }
      },
      cardRequirements: { allowedCardNetworks: allowedCardNetworks }
    };
  }
  getApplePaymentsConfiguration() {
    return {
      version: 3,
      merchantIdentifier: "merchant.au.com.questps.test",
      merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
      supportedNetworks: ["masterCard", "visa"],
      countryCode: "AU"
    };
  }

  getRequest(allowedCardNetworks, total, items, splitType, users, tableTotal) {
    let supportedPaymentMethods = [];
    supportedPaymentMethods.push({
      supportedMethods: 'https://google.com/pay',
      data: this.getGooglePaymentsConfiguration(allowedCardNetworks)
    });
    supportedPaymentMethods.push({
      supportedMethods: 'https://apple.com/apple-pay',
      data: this.getApplePaymentsConfiguration()
    });
    supportedPaymentMethods.push({
      supportedMethods: 'basic-card',
      supportedNetworks: Array.from(allowedCardNetworks, (network) => network.toLowerCase())
    });
    //TODO : WIP : Test custom payment Request -- Called in quest-pay
    const allDisplayItems = [];
    items.forEach(itemDetails => {
      let element = {
        label: itemDetails.name,
        amount: {
          currency: 'AUD',
          value: (itemDetails.total / 100)
        }
      }
      allDisplayItems.push(element);
    });
    if (splitType === "splitequally") {
      allDisplayItems.push({
        // label: `Split equally between ${Object.keys(users).length} users for all ${items.length} items ordered.`,
        label: `Per User Total `,
        amount: {
          currency: 'AUD',
          value: total
        }
      });
    }
    const paymentDetails = {
      total: {
        label: 'Total',
        amount: {
          currency: 'AUD',
          value: total
        }
      },
      displayItems: allDisplayItems,
    };

    // Options isn't required.
    const options = {
      requestPayerName: true,
      requestPayerEmail: true
    };
    let paymentRequest = new window.PaymentRequest(
      supportedPaymentMethods,
      paymentDetails,
      options
    );
    return paymentRequest;
  }
  pay(amountPaid, sumTotal, items, tableID, itemIDs, splitType, users, tableTotal, loggedInUser) {
    console.log(items, itemIDs, splitType);
    // const merchantValidationURL = 'https://1a86d185.ngrok.io/merchant-session/new/'; //localhost ngrok url
    const merchantValidationURL = 'https://us-central1-splice-a918d.cloudfunctions.net/merchantValidation/merchant-session/new/'; //Firebase Function URL
    const allowedCardNetworks = ['VISA', 'MASTERCARD'];
    let itemPromises = [];
    if (window.PaymentRequest) {
      let request = this.getRequest(allowedCardNetworks, sumTotal, items, splitType, users, tableTotal);
      request.onmerchantvalidation = function (event) {
        let sessionPromise = fetch(merchantValidationURL + '?validationURL=' + event.validationURL)
          .then(res => {
            if (!res.ok) {
              throw res.statusText;
            }
            return res.json().then(json => {
              return json;
            });
          });
        event.complete(sessionPromise);

      }
      request.show().then(function (response) {
        itemIDs.forEach((item) => {
          itemPromises.push([
            firebase.database().ref(`/tables/${tableID}/items/${item}/`).update({ paid: true, paymentReference: response.requestId })
          ]);
        });
        if (splitType === 'splitequally') {
          itemPromises.push([
            firebase.database().ref(`/tables/${tableID}/users/${loggedInUser}`).set({
              splitBillPayment: 'paid',
              splitBillTotal: sumTotal,
              paymentReference: response.requestId
            }),
            firebase.database().ref(`/tables/${tableID}/users/${loggedInUser}/userBillPaid`).set(true),
            firebase.database().ref(`/tables/${tableID}`).update({ amountPaid: parseInt(amountPaid, 10) + parseInt(sumTotal, 10) })]);

        } else if (splitType === 'paybyitems') {
          itemPromises.push([
            firebase.database().ref(`/tables/${tableID}/users/${loggedInUser}`).push({
              perItemBillPayment: 'paid',
              perItemBillTotal: sumTotal,
              itemsPaidFor: items,
              paymentReference: response.requestId
            }),
            // firebase.database().ref(`/tables/${tableID}/users/${loggedInUser}/userBillPaid`).set(true),
            firebase.database().ref(`/tables/${tableID}`).update({ amountPaid: parseInt(amountPaid, 10) + (sumTotal * 100) })
          ]);
        }
        if (amountPaid === parseInt(tableTotal, 10)) {
          itemPromises.push([
            firebase.database().ref(`/tables/${tableID}/paymentStatus`).set('paid')
          ])
        }
        response.complete('success');

        return Promise.all(itemPromises);

      }).catch(function (err) {
        console.error(err);
      });
    } else {
      // Fallback to traditional checkout
      console.error("Payments not supported");
    }
  }
  handleChange(event) {
    if (this.props.sumTotal) {
      switch (this.props.devicePlatform) {
        case "android": case "iOS": case "Web":
          this.pay(this.props.amountPaid, this.props.sumTotal, this.props.items, this.props.tableID, this.props.itemKeys, this.props.splitType, this.props.users, this.props.tableTotal, this.props.loggedInUser);
          break;
        case "alipay":
        default:
          break;
      }
    }
  }
  checkIfBillPaid(users, loggedInUser) {
    let state = false;
    Object.entries(users).map((user) => {
      if (user[0] === this.props.loggedInUser) {
        state = user[1].userBillPaid;
      }
    })
    return state;
  }
  render() {
    let userBillPaid = this.checkIfBillPaid(this.props.users, this.props.loggedInUser);
    if (this.props.devicePlatform === 'iOS') {
      if (userBillPaid) {
        return [
          <button className="btn btn-success paid-button" disabled="disabled">
            <span>PAID</span>
          </button>
        ]

      } else {
        return [
          <span className="navbar-brand mb-0 h1 footerBillTotal">
            <p>Bill Total: ${this.props.displayBillTotal}</p>
          </span>,
          <button value={this.props.sumTotal} onClick={this.handleChange} className="apple-pay-button"></button>
        ]
      }

    } else if (this.props.devicePlatform === 'android') {
      if (userBillPaid) {
        return [
          
          <button className="btn btn-success paid-button" disabled="disabled">
            <span>PAID</span>
          </button>
        ]


      } else {
        return [
          <span className="navbar-brand mb-0 h1 footerBillTotal">
            <p>Bill Total: ${this.props.displayBillTotal}</p>
          </span>,
          <button className="btn btn-info pay-button" value={this.props.sumTotal} onClick={this.handleChange}>
            <span>PAY</span>
          </button>
        ]
      }
    } else if(this.props.devicePlatform === 'Web'){
      if (userBillPaid) {
        return [
          
          <button className="btn btn-success paid-button" disabled="disabled">
            <span>PAID</span>
          </button>
        ]


      } else {
        return [
          <span className="navbar-brand mb-0 h1 footerBillTotal">
            <p>Bill Total: ${this.props.displayBillTotal}</p>
          </span>,
          <button className="btn btn-info pay-button" value={this.props.sumTotal} onClick={this.handleChange}>
            <span>PAY</span>
          </button>
        ]
      }
    }else{
      return null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/Components/PayButton.js